<template>
    <div class="un-start">
        <img :src="emptyImg"/>
        <div class="text">投票稍后就来，感谢耐心等待</div>
    </div>
</template>
<script>
import emptyImg from '@/less/images/vote-un-start.png'
export default {
    props: ['articleData'],
    data() {
        return {
            emptyImg
        }
    },
}
</script>
<style lang="less" scoped>
    .un-start {
        width: 100%;
        height: 260px;/*px*/
        box-sizing: border-box;
        padding: 40px 0 32px;/*px*/
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        background: #F8F8F8;
        border-radius: 8px;/*px*/
        margin-bottom: 28px;/*px*/
        img {
            width: 200px !important;/*px*/
            height: 132px !important;/*px*/
            margin-bottom: 0 !important;
        }
        .text {
            height: 40px;/*px*/
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 28px;/*px*/
            color: #999999;
            line-height: 40px;/*px*/
        }
    }
</style>